import React from "react";
import { Route, Routes } from "react-router-dom";
import "./global.css";
import Home from "./routes/Home";
import LoginPage from "./routes/LoginPage";

function App() {
  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginPage />}/>
      </Routes>
    </div>
  );
}

export default App;
